import { MenuPage } from './../menu/menu';
import { AlbumService } from './../../service/album.service';
import { UserService } from '../../service/user.service';
import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { RegisterPage } from '../register/register';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  public isIOS:boolean = false;
  email:string;
  password:string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams, private http: HttpClient,
    public userService: UserService,
    public albumService: AlbumService,
    private storage: Storage,
    public platform: Platform ) {
  }

  ngOnInit(){

    this.storage.get("login").then((data:String) => {

      if (data)
      {
        this.email = data.split("#")[0];
        this.password = data.split("#")[1];
        this.login();
      }

    })

    if (this.platform.is("ios"))
    {
      this.isIOS = true;
    }

  }

  login(){

    //this.email = "linusanderas@gmail.com";
    //this.password = "test";

    this.http.get('https://minmusik.se/api/login?email=' + this.email + "&password=" + this.password ).subscribe(data => {

      if (data != null)
      {

      //  alert(data);
        this.storage.set("login", this.email + "#" + this.password);

        this.userService.user.id = data["id"];
        this.userService.user.email = data["email"];
        this.userService.user.firstname = data["firstname"];
        this.userService.user.lastname = data["lastname"];

        this.albumService.load();
        this.userService.loadPlaylists();

        this.storage.get("quality").then((data:string) => {

          if (data)
          {
            this.userService.user.quality = data;
          }
          else
          {
            this.userService.user.quality = "high";
            this.storage.set("quality", "high");
          }

    
        })

        this.navCtrl.setRoot(MenuPage);
      }
      else
      {
        if (this.email != "")
        {
          alert("fel användarnamn och lösenord")
        }
      }

    });


  }

  register()
  {
    this.navCtrl.push(RegisterPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts